module.exports = __webpack_public_path__ + "img/go-to-icon.7d09ad1e.svg";